import { useEffect, useState } from "react";

// No celular o "? Ajuda" fica em cima das ações alinhadas à direita (ex: "Definir preço"). Some
// enquanto a pessoa desce a página e volta quando ela sobe, perto do topo ou no fim — onde a folga
// do <main> já deixa o canto livre.
export function useSomeAoRolar(ativo: boolean): boolean {
  const [escondido, setEscondido] = useState(false);

  useEffect(() => {
    if (!ativo) {
      setEscondido(false);
      return;
    }
    let anterior = window.scrollY;
    const aoRolar = () => {
      const y = window.scrollY;
      const noFim = window.innerHeight + y >= document.documentElement.scrollHeight - 24;
      if (y < 80 || noFim) {
        setEscondido(false);
        anterior = y;
        return;
      }
      // Rolagem suave dispara eventos de poucos pixels: compara com o último ponto em que decidiu.
      if (Math.abs(y - anterior) < 8) return;
      setEscondido(y > anterior);
      anterior = y;
    };
    window.addEventListener("scroll", aoRolar, { passive: true });
    return () => window.removeEventListener("scroll", aoRolar);
  }, [ativo]);

  return escondido;
}
